var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.hidden
    ? _c("li", [
        _c("div", { staticClass: "event" }, [
          _vm._v(" " + _vm._s(_vm.event.getEventString()) + " "),
        ]),
        _c(
          "div",
          { staticClass: "props" },
          [
            _vm._v(" " + _vm._s(_vm.event.getEventProps()) + " "),
            _vm.event.hasExtraInfo()
              ? _c(
                  "w-link",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("common.info"),
                        expression: "$ct('common.info')",
                      },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.openExtraInfo()
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "info-circle" } })],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.userName
          ? _c("div", { staticClass: "props" }, [
              _c("div", [_vm._v(_vm._s(_vm.userName))]),
            ])
          : _vm._e(),
        _vm.event.UserNfcTag
          ? _c("div", { staticClass: "props nfc-tag" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$ct("with-nfc-tag", { nfcTag: _vm.event.UserNfcTag })
                  ) +
                  " "
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "date" }, [
          _vm._v(" " + _vm._s(_vm.dateString) + " "),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }